/* eslint-disable camelcase */
/* eslint-disable spire/fenced-imports */
/* eslint-disable ordered-imports/ordered-imports */
import React, { Component } from "react";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import setBreadcrumbs from "@insite/client-framework/Store/Components/Breadcrumbs/Handlers/SetBreadcrumbs";
import { connect, ResolveThunks } from "react-redux";
import Link from "@insite/mobius/Link";
import { HasCoveoHooks, withCoveoHooks } from "@NA/Components/Coveo/Contexts/CoveoHooksContext";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { isSearch } from "@NA/Utils/Coveo/CoveoUtils";

const mapStateToProps = (state: CustomApplicationState) => ({
    isSearch: isSearch(state),
    breadcrumbLinks: state.components.breadcrumbs.links,
});

const mapDispatchToProps = {
    setBreadcrumbs,
};

interface OwnProps {
    style?: SearchResultStyles;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasCoveoHooks;

export interface SearchResultStyles {
    container?: InjectableCss;
    searchResultWrapper?: InjectableCss;
    searchCount?: TypographyPresentationProps;
}

export const searchResultStyles: SearchResultStyles = {
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            min-height: 27px;
            height: auto;

            @media screen and (max-width: 1080px) {
                margin-bottom: 0px;
            }
        `,
    },
    searchResultWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            align-items: center;
            font-weight: 300;
            margin-top: -15px;
            font-size: 28px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 20px;
                        margin-top: 0;
                    `,
                    css`
                        margin-bottom: 20px;
                        margin-top: 0;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    searchCount: {
        css: css`
            font-weight: 600;
            margin-right: 5px;
        `,
    },
};

class ProductListCoveoSummary extends Component<Props> {
    handleBreadcrumbs() {
        const { isSearch, summary, setBreadcrumbs } = this.props;
        const query = summary.state?.query;

        if (!isSearch || !query) {
            return;
        }

        const linkText = `${translate("Search Results for")} "${query}"`;
        const lastLink = this.props.breadcrumbLinks?.[this.props.breadcrumbLinks.length - 1];
        
        if (lastLink?.children !== linkText) {
            const links: any = [{ children: translate("Home"), href: "/" }];
            const link = { children: linkText };
            links.push(link);
            setBreadcrumbs({ links });
        }
    }

    UNSAFE_componentWillMount() {
        this.handleBreadcrumbs();
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.summary.state?.query !== this.props.summary.state?.query) {
            this.handleBreadcrumbs();
        }
    }

    render() {
        const { isSearch, summary, didYouMean, searchBox } = this.props;
        const { state: summaryState } = summary;
        const { methods: searchBoxMethods } = searchBox;
        const { state: didYouMeanState } = didYouMean;

        if (!isSearch || summaryState?.isLoading || !summaryState?.query) {
            return null;
        }

        const correctedQuery = didYouMeanState?.queryCorrection?.correctedQuery;
        const wasCorrectedTo = didYouMeanState?.wasCorrectedTo;
        const originalQuery = didYouMeanState?.originalQuery;
        const hasQueryCorrection = didYouMeanState?.hasQueryCorrection;
        const wasAutomaticallyCorrected = didYouMeanState?.wasAutomaticallyCorrected;
        const query = originalQuery || summaryState?.query;

        return (
            <StyledWrapper {...searchResultStyles.container}>
                <StyledWrapper {...searchResultStyles.searchResultWrapper}>
                    <Typography as="p">
                        <Typography {...searchResultStyles.searchCount} as="span">
                            {summaryState?.hasProducts && summaryState?.totalNumberOfProducts.toLocaleString()}
                        </Typography>
                        <Typography as="span">Results for "{query}"</Typography>
                    </Typography>
                </StyledWrapper>
                <StyledWrapper>
                    {hasQueryCorrection && !wasAutomaticallyCorrected && (
                        <Typography>
                            Search instead for{" "}
                            <Link
                                onClick={() => {
                                    if (!correctedQuery) return;
                                    searchBoxMethods?.updateText(correctedQuery);
                                    searchBoxMethods?.submit();
                                }}
                            >
                                {correctedQuery}
                            </Link>
                        </Typography>
                    )}
                    {wasAutomaticallyCorrected && <Typography>Search corrected to {wasCorrectedTo}</Typography>}
                </StyledWrapper>
            </StyledWrapper>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withCoveoHooks(ProductListCoveoSummary));
